<template>
  <v-autocomplete
    outline
    v-model="current"
    :items="list.data"
    :label="translation(filterName)"
    :item-text="translatedName"
    item-value="value"
    :multiple="list.multiple"
    clearable
    :disabled="list.disabled"
    :hint="hint"
    persistent-hint
    :return-object = "list.returnObject"
    @change="setFilter">
    <template v-if="list.multiple" v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item.name }}</span>
      </v-chip>
      <span
        v-if="index === 1"
        class="grey--text caption"
      >(+{{ current.length - 1 }} others)</span>
    </template>
    <template v-if="!list.multiple" v-slot:selection="{ item, index }">
        <span>{{ item.name }}</span>
    </template>
    <template v-slot:prepend-item v-if="list.multiple && list.data && list.data.length">
      <v-list-tile
        ripple
        @click="toggleItem">
        <v-list-tile-action>
          <v-icon :color="current.length > 0 ? 'primary' : ''">
            {{ allIcon }}
          </v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ translation('filters.select.select-all') }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FilterSelect',
  props: {
    filterId: { type: String, required: true },
    filterKey: { type: String, required: true },
    filterName: { type: String, required: true }
  },
  data () {
    return {
      hint: ''
    }
  },
  computed: {
    ...mapGetters(['translation']),
    list () { return this.$store.getters.filterItemGen(this.filterId) },
    current: {
      set (val) { this.$store.commit('GEN_SET_SELECTED_FILTER_ITEM', { key: this.filterId, value: val }) }, // TODO handle val === 'undefined' for single item select on Clear
      get () { return this.$store.getters.selectedItemGen(this.filterId) }
    },
    selectedAll () { return this.current.length === this.list.data.length },
    selectedSome () { return this.current.length > 0 && !this.selectedAll },
    allIcon () {
      if (this.selectedAll) return 'check_box'
      if (this.selectedSome) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    }
  },
  created () {
    this.hint = this.list.multiple
      ? this.translation('filter.filter-by') + ' ' + this.translation(this.filterName) + ' ' + this.translation('filter.multiple-choose-available')
      : this.translation('filter.filter-by') + ' ' + this.translation(this.filterName)
  },
  methods: {
    toggleItem () {
      this.$nextTick(() => {
        this.selectedAll ? this.current = [] : this.current = this.list.data.map(item => item.value)
        this.setFilter()
      })
    },
    setFilter () {
      // emit event for fetching data
      this.$emit('update-filters')
    },
    translatedName (item) {
      return item.translatedName ? item.translatedName : item.name
    }
  }
}
</script>

<style>
 .v-autocomplete .v-input__slot {
   border: 1px solid darkgray !important;
 }
</style>
